import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL,
 headers: {
 Authorization: `Bearer ${getToken()}`,
 "Content-Type": "application/json",
 },
});

export const fetchAllSocialMedia = async () => {
 try {
 const response = await api.get("/admin/social-media");
 return { status: response.status, data: response.data };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 data: [],
 message: err.response?.data?.message || "Failed to fetch social media entries",
 };
 }
};

export const createSocialMedia = async (payload) => {
 try {
 const response = await api.post("/admin/social-media", payload);
 return { status: response.status, data: response.data };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 message: err.response?.data?.message || "Failed to create entry",
 };
 }
};

export const updateSocialMedia = async (id, payload) => {
 try {
 const response = await api.put(`/admin/social-media/${id}`, payload);
 return { status: response.status, data: response.data };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 message: err.response?.data?.message || "Failed to update entry",
 };
 }
};

export const deleteSocialMedia = async (id) => {
 try {
 const response = await api.delete(`/admin/social-media/${id}`);
 return { status: response.status };
 } catch (err) {
 return {
 status: err.response?.status || 500,
 message: err.response?.data?.message || "Failed to delete entry",
 };
 }
};
